import { useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';
import { ConfiguredCarInput } from '@oneaudi/onegraph-client';
import { SelectedStandardEquipmentDocument } from '~/graphql/__generated__/graphql';

export function useConfiguredCarDynamicCatalog() {
	const [fetchDynamicCatalogData, { data, previousData, loading }] = useLazyQuery(SelectedStandardEquipmentDocument, {
		returnPartialData: true,
		fetchPolicy: 'no-cache',
	});

	const fetchDynamicCatalog = useCallback(
		(configuredCar: ConfiguredCarInput) => {
			return fetchDynamicCatalogData({
				variables: {
					configuredCar,
					featuresFilterInput: {
						filterByFeatureState: ['selected', 'standard', 'available'],
					},
				},
			});
		},
		[fetchDynamicCatalogData],
	);

	return {
		fetchDynamicCatalog,
		selectedStandardEquipmentDynamic: data ?? previousData,
		isLoading: loading,
	};
}
